import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VersionCheckResponse } from '@shared/models/version-check/version-check.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private http: HttpClient) {}

  checkVersion(): Observable<VersionCheckResponse> {
    // Sempre na API default (não versionada): no app nativo, baseUrlApi aponta
    // para a API congelada do release (nrN-dot-...), cujas env vars são baked —
    // ela sempre responde updateAvailable: false para o próprio release.
    return this.http.get<VersionCheckResponse>(`${environment.baseUrlApiDefault}/version/check`);
  }
}
